import { render, staticRenderFns } from "./LatestNoticeSystem.vue?vue&type=template&id=58dbdf61&scoped=true"
import script from "./LatestNoticeSystem.vue?vue&type=script&lang=js"
export * from "./LatestNoticeSystem.vue?vue&type=script&lang=js"
import style0 from "./LatestNoticeSystem.vue?vue&type=style&index=0&id=58dbdf61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dbdf61",
  null
  
)

export default component.exports